<template>
  <div
    class="hierarchy-box btn-radius overflow-hidden shadow-lg hierarchy-bg-color p-6"
    :style="[customCss]"
    :class="isOutlineSticky == 1 ? 'sticky' : ''"
  >
    <div
      class="campton-font font-bold mb-4 text-2xl font-bold hierarchy-heading-color"
    >
      {{ $t('frontend_content') }}
    </div>

    <VuePerfectScrollbar>
      <div class="accordion-sidebar-height lg:px-6">
        <!--Start Category Section--->

        <div
          class="accordion-tab text-sm text-dark mb-3 hierarchy-text-color"
          v-for="(category, index) in hierarchy"
          :key="index"
        >
          <div @click="category.is_default ? () => {} : sidebarToggle(index)">
            <label
              class="flex justify-between select-none mb-2 campton-font cursor-pointer"
              :class="{ tabactive: index == tabactive }"
            >
              <span
                v-if="!category.is_default"
                class="cursor-pointer campton-font hierarchy-text-color font-bold"
                > {{ category.name }}
              </span>
              <span
                v-else
                @click="
                  category.is_default
                    ? activateElement({ e: '', el: category })
                    : () => {}
                "
                class="cursor-pointer campton-font hierarchy-text-color font-bold"
                > {{ category.name }}
              </span>

              <div
                v-if="!category.is_default"
                class="rounded-full flex items-center justify-center"
              >
                <span :class="[category.is_collapsed ? 'block' : 'hidden']">
                  <i class="fa fa-chevron-up arrow-grey"></i>
                </span>
                <span
                  class="mt-1"
                  :class="[category.is_collapsed ? 'hidden' : 'block']"
                >
                  <i class="fa fa-chevron-right arrow-grey"></i>
                </span>
              </div>
            </label>
          </div>
          <!----Start Sub Category Section-->
          <ul
            class="accordion-tab-content overflow-hidden"
            :class="[category.is_collapsed ? 'block' : 'hidden']"
          >
            <li
              v-for="(subcategory, i) in category.children.filter(
                (subcategory) => !subcategory.is_hidden
              )"
              :key="i"
              :class="[
                isPreview &&
                subcategory.type === 'post' &&
                subcategory.is_locked.status
                  ? 'lesson-icon relative'
                  : 'no-icon',
              ]"
              @click="
                !isPreview && subcategory.type === 'post'
                  ? activateElement({ e: '', el: subcategory })
                  : subcategory.type == 'post'
                  ? sendToPath({
                      name: 'post',
                      params: { id: subcategory.slug },
                    })
                  : () => {}
              "
            >
              <div
                v-if="subcategory.children.every((post) => !post.is_hidden)"
                @click="sidebarToggleChild(index, i)"
                class="px-3 py-2 cursor-pointer campton-font flex"
                :class="
                  (heighlightHierarchy(subcategory)
                    ? 'content-list-active'
                    : 'non-active-subcat',
                  subcategory.type == 'post'
                    ? 'items-center'
                    : 'justify-between font-bold')
                "
              >
                <div v-if="subcategory.type == 'post' && sidebarType == 2">
                  <i
                    :class="subcategory.post_icon"
                    class="post_icon_font mr-2 text-xs"
                  ></i>
                </div>
                {{ subcategory.name }}

                <div
                  v-if="subcategory.type == 'subcategory'"
                  class="rounded-full flex items-center justify-center"
                >
                  <span
                    :class="[subcategory.is_collapsed ? 'block' : 'hidden']"
                  >
                    <i class="fa fa-chevron-up arrow-grey"></i>
                  </span>
                  <span
                    class="mt-1"
                    :class="[subcategory.is_collapsed ? 'hidden' : 'block']"
                  >
                    <i class="fa fa-chevron-right arrow-grey"></i>
                  </span>
                </div>
              </div>

              <ul
                :id="subcategory.id"
                :class="[subcategory.is_collapsed ? 'block' : 'hidden']"
              >
                <li
                  v-for="(post, index) in subcategory.children.filter(
                    (post) => !post.is_hidden
                  )"
                  class="pl-3"
                  :key="index"
                  :class="[
                    isPreview && post.type === 'post' && post.is_locked.status
                      ? 'lesson-icon relative'
                      : 'no-icon',
                  ]"
                >
                  <div
                    @click="
                      !isPreview
                        ? activateElement({ e: '', el: post })
                        : sendToPath({
                            name: 'post',
                            params: { id: post.slug },
                          })
                    "
                    :class="
                      heighlightHierarchy(post)
                        ? 'content-list-active '
                        : 'non-active'
                    "
                    class="cursor-pointer post-link px-3 py-2 display-none cursor-default flex items-center campton-font"
                  >
                    <i
                      v-if="sidebarType == 2"
                      :class="post.post_icon"
                      class="post_icon_font mr-2"
                    ></i>
                    <i v-else class="fas fa-stream mr-2"></i>
                    {{ post.name }}
                  </div>
                </li>
              </ul>
            </li>
          </ul>
          <!----End Sub Category Section-->
        </div>
        <!--End Category Section--->
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'Hierarchy',
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      tabactive: 0,
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    hierarchy: {},
    activeElement: {},
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    getThemeSettings: {},
    isOutlineSticky: {},
    sidebarType: {},
  },
  computed: {
    themeSettings() {
      return this.getThemeSettings();
    },
    customCss() {
      return {
        '--hierarchy-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--hierarchy-content-color': this.themeSettings.configuration_options
          .section_content_color,
        '--hierarchy-heading-color': this.themeSettings.configuration_options
          .section_heading_color,
      };
    },
  },
  methods: {
    toggle(id) {
      this.hierarchy.forEach((element, id) => {
        this.hierarchy[i].is_collapsed = false;
      });
      this.hierarchy[indexElement].is_collapsed = !this.hierarchy[indexElement]
        .is_collapsed;
    },
    heighlightHierarchy(item) {
      return this.activeElement.value.id === item.id;
    },
    sidebarToggle(indexElement) {
      this.hierarchy.forEach((element, index) => {
        if (index === indexElement) return;
        this.hierarchy[index].is_collapsed = false;
      });
      this.hierarchy[indexElement].is_collapsed = !this.hierarchy[indexElement]
        .is_collapsed;
    },

    sidebarToggleChild(outerIndex, innerIndex) {
      this.hierarchy.forEach((element, index) => {
        this.hierarchy[index].children.forEach((e, i) => {
          if (i == innerIndex) return;
          this.hierarchy[index].children[i].is_collapsed = false;
        });
      });
      this.hierarchy[outerIndex].children[innerIndex].is_collapsed = !this
        .hierarchy[outerIndex].children[innerIndex].is_collapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
.hierarchy-box.sticky {
  top: 20px;
}
.hierarchy-heading-color {
  color: var(--hierarchy-heading-color);
}

.hierarchy-bg-color {
  background: var(--hierarchy-bg-color);
}

.hierarchy-text-color {
  color: var(--hierarchy-content-color);
}

.content-list-active {
  background: #d5dbec;
  color: #0047ff;
  border-radius: 6px;
}

.canvas-text-blue {
  color: #0047ff;
}

.canvas-bg-blue {
  background: #0047ff;
}

.accordion-tab-content li .cursor-pointer:hover {
  background: #e8eeff;
  color: #0047ff;
  border-radius: 6px;
}
.lesson-icon {
  &::before {
    top: 10px;
    right: 10px;
    position: absolute;
    width: 14px;
    height: 17px;
    background: url('../../../assets/images/icons/lesson-lock.png');
    display: inline-block;
    content: '';
    outline: none;
    color: #fff;
  }
}
.hidden-submenus + .accordion-tab-content {
  display: none;
}
.accordion-sidebar-height {
  max-height: 400px;
}
.post_icon_font {
  font-size: 16px;
}
</style>
